import { render } from "./Free.vue?vue&type=template&id=29607515&scoped=true"
import script from "./Free.vue?vue&type=script&lang=js"
export * from "./Free.vue?vue&type=script&lang=js"

import "./Free.vue?vue&type=style&index=0&id=29607515&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29607515"]])

export default __exports__